import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

const STATUS_MAP = {
  WAITING_HOTEL_CALL: { label: 'Otelci arayacak', cls: 'badge-blue'   },
  DEPOSIT_RECEIVED:   { label: 'Kapora Alındı',   cls: 'badge-yellow' },
  PENDING:            { label: 'Bekliyor',         cls: 'badge-yellow' },
  CONFIRMED:          { label: 'Kesinleşti',       cls: 'badge-green'  },
  REJECTED:           { label: 'Reddedildi',       cls: 'badge-red'    },
  CANCELLED:          { label: 'İptal',            cls: 'badge-gray'   },
};

const TABS = [
  { id: '',                   label: 'Tümü' },
  { id: 'WAITING_HOTEL_CALL', label: '📞 Otelci Arayacak' },
  { id: 'DEPOSIT_RECEIVED',   label: '💰 Kapora Alındı' },
  { id: 'CONFIRMED',          label: 'Kesinleşti' },
  { id: 'REJECTED',           label: 'Reddedildi' },
];

export default function ReservationsPage() {
  const [reservations, setReservations] = useState([]);
  const [activeTab, setActiveTab] = useState('');
  const navigate = useNavigate();

  const fetchReservations = () => {
    const params = activeTab ? `?status=${activeTab}` : '';
    api.get(`/reservations${params}`).then(data => setReservations(data.reservations || []));
  };

  useEffect(() => { fetchReservations(); }, [activeTab]);

  const handleConfirm = async (id) => {
    try { await api.post(`/reservations/${id}/confirm`); toast.success('Onaylandı'); fetchReservations(); }
    catch { toast.error('Hata'); }
  };

  const handleReject = async (id) => {
    const reason = prompt('Red sebebi (opsiyonel):');
    try { await api.post(`/reservations/${id}/reject`, { reason }); toast.success('Reddedildi'); fetchReservations(); }
    catch { toast.error('Hata'); }
  };

  const handleMarkDepositReceived = async (id) => {
    try {
      await api.post(`/reservations/${id}/mark-deposit-received`);
      toast.success('Kapora alındı olarak işaretlendi');
      fetchReservations();
    } catch { toast.error('Hata'); }
  };

  const handleDepositConfirm = async (id) => {
    try {
      await api.post(`/reservations/${id}/deposit-confirm`);
      toast.success('Ödeme onaylandı, rezervasyon kesinleşti!');
      fetchReservations();
    } catch { toast.error('Hata'); }
  };

  return (
    <div style={{ padding: 28 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 20 }}>Rezervasyonlar</h1>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '2px solid #e2e8f0', overflowX: 'auto' }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)} style={{
            padding: '8px 16px', border: 'none', background: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap',
            color: activeTab === t.id ? '#3b82f6' : '#64748b',
            borderBottom: activeTab === t.id ? '2px solid #3b82f6' : '2px solid transparent',
            marginBottom: -2,
          }}>{t.label}</button>
        ))}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {reservations.map(r => (
          <div key={r.id} className="card" style={{ padding: '16px 20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 16 }}>{r.customerName}</div>
                <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>
                  📱 {r.customerPhone || 'Telefon yok'} · ✉️ {r.customerEmail || 'Email yok'}
                </div>
                <div style={{ fontSize: 13, color: '#1e293b', marginTop: 6 }}>
                  <strong>Giriş:</strong> {format(new Date(r.checkIn), 'd MMMM yyyy', { locale: tr })} →{' '}
                  <strong>Çıkış:</strong> {format(new Date(r.checkOut), 'd MMMM yyyy', { locale: tr })}
                </div>
                <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>
                  {r.adults} yetişkin{r.children > 0 ? `, ${r.children} çocuk` : ''}
                  {r.room ? ` · ${r.room.name}` : ''}
                  {r.totalPrice ? ` · ₺${r.totalPrice.toLocaleString()}` : ''}
                </div>

                {/* Hotelier101 queueId */}
                {r.hotelier101QueueId && (
                  <div style={{ marginTop: 8, fontSize: 12, color: '#6366f1' }}>
                    🔗 Hotelier101 kuyruk: {r.hotelier101QueueId}
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6, marginLeft: 16 }}>
                <span className={`badge ${STATUS_MAP[r.status]?.cls}`}>{STATUS_MAP[r.status]?.label}</span>
                <span className={`badge ${r.channel === 'INSTAGRAM' ? 'badge-blue' : 'badge-green'}`} style={{ fontSize: 11 }}>{r.channel}</span>
              </div>
            </div>

            {/* Aksiyon butonları */}
            <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
              {r.status === 'WAITING_HOTEL_CALL' && (
                <>
                  <button className="btn btn-primary" onClick={() => handleMarkDepositReceived(r.id)}>💰 Kapora Alındı</button>
                  <button className="btn btn-success" onClick={() => handleConfirm(r.id)}>✅ Kesinleştir</button>
                  <button className="btn btn-danger" onClick={() => handleReject(r.id)}>Reddet</button>
                </>
              )}
              {r.status === 'DEPOSIT_RECEIVED' && (
                <>
                  <button className="btn btn-success" onClick={() => handleConfirm(r.id)}>✅ Kesinleştir</button>
                  <button className="btn btn-danger" onClick={() => handleReject(r.id)}>Reddet</button>
                </>
              )}
              {r.status === 'PENDING' && (
                <>
                  <button className="btn btn-success" onClick={() => handleConfirm(r.id)}>Onayla</button>
                  <button className="btn btn-danger" onClick={() => handleReject(r.id)}>Reddet</button>
                </>
              )}
              {r.conversationId && (
                <button className="btn btn-secondary" onClick={() => navigate(`/conversations/${r.conversationId}`)}>Konuşmayı Gör</button>
              )}
            </div>
          </div>
        ))}
        {reservations.length === 0 && (
          <div style={{ textAlign: 'center', color: '#94a3b8', padding: 40 }}>Rezervasyon bulunamadı</div>
        )}
      </div>
    </div>
  );
}
